import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-container-id"]
const _hoisted_2 = {
  class: "truncate text-[11px] text-neutral50",
  "data-testid": "ds-attendance-sla-line-text"
}

import { computed } from 'vue'

import ModuleViewSlaChip from '@/components/designSystem/QueueViews/ModuleViewSlaChip.vue'
import type { DSAttendanceContainer } from '@/types/ds-attendance.types'

import { containerSlaLineText } from '../../utils/queue-sla-line'

/** Chip + "Prazo de envio/auditoria · data · janela" (CA2). Um relógio por tela: `nowMs` por prop. */

export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceSlaLine',
  props: {
    container: {},
    nowMs: {}
  },
  setup(__props: any) {

const props = __props;



const text = computed(() => containerSlaLineText(props.container))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex min-w-0 flex-col gap-0.5",
    "data-testid": "ds-attendance-sla-line",
    "data-container-id": _ctx.container.id
  }, [
    _createVNode(ModuleViewSlaChip, {
      sla: _ctx.container.sla ?? null,
      "now-ms": _ctx.nowMs
    }, null, 8, ["sla", "now-ms"]),
    _createElementVNode("span", _hoisted_2, _toDisplayString(text.value), 1)
  ], 8, _hoisted_1))
}
}

})